// extracted by mini-css-extract-plugin
export default {"privacy-container":"profile_privacy-container__ZyXgN","privacy-toggle-container":"profile_privacy-toggle-container__bvq-a"};